module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-lig-926f61dd6fe56b137360f9479d02bdfe.svg";